/* eslint-disable */
import ApiService from '@/services/Base/ApiService';

const getDefaultState = () => {
  return {
    savedSourceDatas: null,
    savedNotableIndividualSourceDatas: null,
  }
}

const state = getDefaultState()

const getters = {
}

const mutations = {
}

const actions = {
  async fetchAncientProxSourceData(context) {
    try {
      const saveDetail = context.state.savedSourceDatas;
      if (saveDetail) {
        return saveDetail;
      } else {
        const response = await ApiService.get('AncientProxSourceData');
        if (response.statusCode === 200) {
          context.state.savedSourceDatas = response.result;
          return response.result;
        } else {
          throw error;
        }
      }
    } catch (error) {
      throw error;
    }
  },

  async fetchNotableIndividualSourceData(context) {
    try {
      const saveDetail = context.state.savedNotableIndividualSourceDatas;
      if (saveDetail) {
        return saveDetail;
      } else {
        const response = await ApiService.get('AncientProxSourceData/notable-individual');
        if (response.statusCode === 200) {
          context.state.savedNotableIndividualSourceDatas = response.result;
          return response.result;
        } else {
          throw error;
        }
      }
    } catch (error) {
      throw error;
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
